import CryptoJS from 'crypto-js';

const secretIv = '1168888413868258';
const secretKey = '7008939800596502';

function getKeyAndIv() {
    const key = CryptoJS.SHA256(secretKey);
    const ivHash = CryptoJS.SHA256(secretIv).toString(CryptoJS.enc.Hex).substring(0, 32);
    const iv = CryptoJS.enc.Hex.parse(ivHash);
    return { key, iv };
}

function IUCrypto() {
    this.encriptar = function(obj) {
        const texto = JSON.stringify(obj);
        const { key, iv } = getKeyAndIv();

        const encrypted = CryptoJS.AES.encrypt(texto, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return encrypted.toString(); // Texto cifrado (base64)
    }

    this.desencriptar = function(textoCifrado) {
        const { key, iv } = getKeyAndIv();

        const decrypted = CryptoJS.AES.decrypt(textoCifrado, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const texto = decrypted.toString(CryptoJS.enc.Utf8);
        return JSON.parse(texto); // Vuelve a objeto original
    }
}

export default IUCrypto
